import { render } from "./CUTax.vue?vue&type=template&id=7d3becfe&scoped=true"
import script from "./CUTax.vue?vue&type=script&lang=js"
export * from "./CUTax.vue?vue&type=script&lang=js"

import "./CUTax.vue?vue&type=style&index=0&id=7d3becfe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d3becfe"]])

export default __exports__